import { useQuery } from '@tanstack/react-query';
import api from './authService';

export const adminServicesReportKeys = {
  all: ['admin', 'services-report'],
  report: (filters) => [...adminServicesReportKeys.all, filters],
};

const buildParams = (filters) => {
  const params = {};
  if (filters.period && filters.period !== 'custom') params.period = filters.period;
  if (filters.period === 'custom' || filters.date_from) params.date_from = filters.date_from;
  if (filters.period === 'custom' || filters.date_to) params.date_to = filters.date_to;
  if (filters.date_field) params.date_field = filters.date_field;
  if (filters.vendor_id && filters.vendor_id !== 'all') params.vendor_id = filters.vendor_id;
  if (filters.category_id && filters.category_id !== 'all') params.category_id = filters.category_id;
  if (filters.status && filters.status !== 'all') params.status = filters.status;
  if (filters.search?.trim()) params.search = filters.search.trim();
  return params;
};

export const fetchAdminServicesReport = async (filters = {}) => {
  const response = await api.get('/admin/reports/services', { params: buildParams(filters) });
  return response.data;
};

export const exportAdminServicesReportCsv = async (filters = {}) => {
  const response = await api.get('/admin/reports/services/export', {
    params: buildParams(filters),
    responseType: 'blob',
  });
  return response.data;
};

export const useAdminServicesReport = (filters, options = {}) => {
  return useQuery({
    queryKey: adminServicesReportKeys.report(filters),
    queryFn: () => fetchAdminServicesReport(filters),
    staleTime: 60 * 1000,
    ...options,
  });
};
